import declare from "dojo/_base/declare";
import _ from "csi/_base/underscore";
import Widget from "csi/table/Widget";
import CareInstructionsandIconsMatrix from "./CareInstructionsAndIconsMatrix";

const CareInstructionsAndIconTableController = declare(Widget, {
	activeProductSalesRegions : [],
	_resolveColumns: function() {
		const { activeProductSalesRegions } = this;
		if (!this.activeProductSalesRegions) {
			this.attributeSpecs.cells = this.attributeSpecs.cells.filter((e) => e.heading.m_nameOrig !== "CareInstructionsAndIconsMatrix");
		}
		this.inherited(arguments);
	},
	
	/** return object containing properties from view necessary to recreate it for printing that are not custom view options */
	getPrintProperties: function(): Record<string, any> {
		const params = this.inherited(arguments) as any;
		params.activeProductSalesRegions = this.activeProductSalesRegions;
		return params;
	},

});
export = CareInstructionsAndIconTableController;